import TrustBar from '../../components/feature/TrustBar';
import PageHero from '../../components/feature/PageHero';
import AboutContent from './components/AboutContent';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import Process from '../../components/feature/Process';
import WhyChoose from '../../components/feature/WhyChoose';
import ServiceAreas from '../../components/feature/ServiceAreas';
import Testimonials from '../../components/feature/Testimonials';
import FAQ from '../../components/feature/FAQ';
import FinalCTA from '../../components/feature/FinalCTA';
import type { AIQAItem } from '../../components/feature/AIAnswerBlock';
import type { FAQItem } from '../../components/feature/FAQ';

const aiItems: AIQAItem[] = [
  {
    question: 'Who is Talo Architect?',
    answer:
      'Talo Architect is a residential architecture studio based in Scarsdale, NY, founded in 2002. The firm designs custom homes, renovations, and additions with a modern, intentional approach — prioritizing clarity, livability, and long-term design value for clients across New York City and Westchester County.',
  },
  {
    question: 'What is the design philosophy at Talo Architect?',
    answer:
      'The design philosophy is rooted in how people actually live. Every spatial decision, material choice, and design detail is made in service of function, natural light, and long-term livability — not trend. Architecture should feel inevitable, not imposed.',
  },
  {
    question: 'What types of clients does Talo Architect work with?',
    answer:
      'We work with residential clients who value thoughtful, high-quality design — whether building a custom home, renovating an existing residence, or planning a meaningful addition. Clients typically prioritize design integrity, personal collaboration, and lasting architectural value in their homes.',
  },
];

const whyItems = [
  'Deeply personalized, collaborative design process',
  'Modern residential architectural expertise since 2002',
  'Refined, detail-driven execution — no shortcuts taken',
  'Client-centered from first meeting to final build',
  'Architecture designed to hold its value for decades',
  'Local expertise across NYC and Westchester County',
];

const faqItems: FAQItem[] = [
  {
    question: 'What type of architectural projects do you take on?',
    answer:
      'Talo Architect focuses on residential architecture — custom homes, renovations, additions, and interior spatial planning across New York City and Westchester County. Each project is reviewed individually to ensure we can provide the level of attention and design care the work requires.',
  },
  {
    question: 'Do you work with builders and general contractors?',
    answer:
      'Yes. We collaborate with builders and contractors throughout the NYC and Westchester region regularly. We provide complete construction documentation and remain available during the build to answer design questions and support the contractor\'s execution of the project.',
  },
  {
    question: 'Can you help with home renovations in Westchester County?',
    answer:
      'Absolutely. Renovation design is a core part of our practice. We have extensive experience with residential renovations across Westchester County — including additions, interior reconfiguration, and exterior transformations for homes in Scarsdale, White Plains, Bronxville, and surrounding areas.',
  },
  {
    question: 'How do I begin working with Talo Architect?',
    answer:
      'The first step is a consultation, where we discuss your project, vision, timeline, and goals. This allows us to understand the scope and determine the right design approach for your specific property and residential architecture needs in the NYC or Westchester area.',
  },
];

export default function AboutPage() {
  return (
    <>
      <PageHero
        eyebrow="Talo Architect, P.C. · Est. 2002"
        title="A Thoughtful Approach to Residential Architecture"
        subtitle="Designing homes that reflect how people live — with precision, purpose, and enduring form."
        primaryCta="Work With Talo Architect"
        bgImage="https://public.readdy.ai/ai/img_res/24b66db6dc8d0a876cdf74158edb4129.jpg"
      />
      <TrustBar />
      <AboutContent />
      <AIAnswerBlock items={aiItems} title="About the Studio" />
      <Process ctaText="Start a Conversation" />
      <WhyChoose items={whyItems} />
      <ServiceAreas />
      <Testimonials />
      <FAQ items={faqItems} title="Working With Us" />
      <FinalCTA
        headline="Let's Design Something Together"
        subline="Great architecture starts with a great conversation. We'd love to hear about your project."
        primaryCta="Work With Talo Architect"
        secondaryCta="Call (914) 645-2940"
      />
    </>
  );
}
